import BreadScrumbs from "../../components/breadscrumb";
import Token from "../../assets/images/token.png"
import { useState,useEffect } from "react";
import Merge from "../../components/merge";
import Box from "../../components/box";
import NFT from "../../components/nft";
function RefferalProgramPage() {
    const [address, setAddress] = useState()
    const listReferral = [
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
        {
            date: '10/12/2022',
            address: '0x2170e...8956bd',
            earn: 12
        },
    ]
    const listLevelCommission = [
        { level: 1, commision: '5%' },
        { level: 2, commision: '2%' },
        { level: 3, commision: '25%' },
        { level: 4, commision: '5%' },
        { level: 5, commision: '2%' },
        { level: 6, commision: '25%' },
        { level: 3, commision: '25%' },
        { level: 2, commision: '30%' },
        { level: 5, commision: '78%' },
        { level: 6, commision: '25%' },
    ]

    const itemPerPage = 12
    const numberPage = Math.ceil(listReferral.length / itemPerPage)
 
    const [currentList, setCurrentList] = useState(() => { return (listReferral.slice(0, itemPerPage)) })
    const [currentPage, setCurrentPage] = useState(0)
    useEffect(() => {
        setCurrentList(() => {
            return listReferral.slice(currentPage * itemPerPage, (currentPage + 1) * itemPerPage)
        })
    }, [currentPage])
    function handlePrevPage() {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1)
        }
    }
    function handleNextPage() {
        if (currentPage < numberPage - 1) {
            setCurrentPage(currentPage + 1)
        }
    }

    return (
        <>
            <BreadScrumbs name={'Refferal Program'} />
            <div className="w-full relative  px-[6.4rem] py-[7.8rem] xl:px-[25.5rem] flex flex-col-reverse items-center md:flex-row md:justify-between md:items-start  gap-[6.4rem] flex-nowrap">
                <div className="w-full ">
                    <div className="w-full h-[72.2rem] bg-third px-[2.4rem] py-[2.9rem] rounded-[1rem]">
                        <p className="text-white text-[20px] font-bakbak mb-[2rem] font-normal">Referral list</p>
                        <table className="w-full">
                            <thead>
                                <tr>
                                    <td className=' py-[1.2rem] text-white text-[2rem] font-bakbak font-normal'>Date</td>
                                    <td className=' py-[1.2rem] text-white text-[2rem] font-bakbak font-normal'>Wallet Address</td>
                                    <td className=' py-[1.2rem] text-white text-[2rem] font-bakbak font-normal'>Earned</td>
                                </tr>
                            </thead>
                            <tbody >
                                {currentList.map((item, index) => (
                                    <tr key={index}>
                                        <td className="py-[1.2rem] text-[#C2C3C5] text-[1.6rem] font-poppin font-normal">{item.date}</td>
                                        <td className="py-[1.2rem] text-[#C2C3C5] text-[1.6rem] font-poppin font-normal">{item.address}</td>
                                        <td className="py-[1.2rem]  flex justify-start gap-[0.4rem] items-center">
                                            <div className="w-[2.4rem] h-[2.4rem]">
                                                <img src={Token} alt="token" />
                                            </div>
                                            <span className="text-primary text-[2rem] font-bakbak  font-normal">{item.earn}</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="flex justify-end items-center gap-[1.6rem] mt-[5rem]">
                        <div onClick={handlePrevPage} className={`prev bg-transparent relative cursor-pointer transition-all rotate-180 duration-300 w-[5rem] h-[5rem] flex justify-center items-center rounded-full border-primary  border`}>
                            <div className="border-t-[0.4rem] -r-black rounded-tr-md border-r-[0.4rem] w-[1.8rem] h-[1.8rem] border-t-white border-r-white rotate-45 absolute top-[1.4rem] left-[1.2rem]">
                            </div>
                        </div>
                        {
                            Array.from(Array(numberPage), (e, i) => {
                                return (
                                    <div onClick={() => setCurrentPage(i)} key={i} className={`${currentPage === i ? 'text-primary bg-third' : 'text-white bg-transparent'} cursor-pointer transition-all duration-300 w-[5rem] h-[5rem] flex justify-center items-center rounded-full border-third  border`}>
                                        <p className={`text-[1.8rem] font-poppin `}>{i + 1}</p>
                                    </div>
                                )
                            })
                        }
                        <div onClick={handleNextPage} className={` next  bg-transparent relative cursor-pointer transition-all duration-300 w-[5rem] h-[5rem] flex justify-center items-center rounded-full border-primary  border`}>
                            <div className="border-t-[0.4rem] -r-black rounded-tr-md border-r-[0.4rem] w-[1.8rem] h-[1.8rem] border-t-white border-r-white rotate-45 absolute top-[1.4rem] left-[1.2rem]">

                            </div>
                        </div>
                    </div>
                </div>
               <div className="w-full md:max-w-[48rem]">
                    <div className="bg-third p-[2rem] rounded-[1rem]">
                        <p className="text-white text-[20px] font-bakbak mb-[2rem] font-normal">My Refferal Program</p>
                        <div className="border-2 border-primary rounded-[1rem] px-[1.8rem] bg-transparent flex justify-start gap-[1.2rem]">
                            <input className="w-full focus:bg-transparent visited:bg-transparent bg-transparent outline-none  py-[0.8rem] text-[16px] text-white font-bakbak font-normal" type="text" name="address" value={address} onChange={(e) => setAddress(e.value)} />
                            <button className="text-primary text-[20px] font-bakbak  font-normal" type="">Copy</button>
                        </div>
                    </div>
                    <div className="flex flex-wrap justify-start md:justify-between gap-[1rem] mt-[2rem]">
                        <div className=" bg-third p-[2rem] rounded-[1rem]">
                            <p className="text-white text-[20px] font-bakbak mb-[1.2rem] font-normal">Total Friend</p>
                            <div className=" flex justify-start items-center gap-[0.6rem]">
                                <svg width="2.1rem" height="2.1rem" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.0003 13.0001C16.9473 13.0001 16.9003 13.0141 16.8453 13.0161L13.8173 7.83811C14.3802 7.28011 14.7647 6.56745 14.9219 5.79057C15.079 5.01369 15.0019 4.20763 14.7002 3.47469C14.3985 2.74174 13.8858 2.11495 13.2272 1.67387C12.5687 1.2328 11.7939 0.997314 11.0013 0.997314C10.2087 0.997314 9.43394 1.2328 8.77538 1.67387C8.11683 2.11495 7.60416 2.74174 7.30244 3.47469C7.00073 4.20763 6.92357 5.01369 7.08075 5.79057C7.23794 6.56745 7.62239 7.28011 8.18531 7.83811L5.16631 13.0171C5.10931 13.0141 5.05731 13.0001 5.00031 13.0001C4.25158 12.9975 3.51716 13.2051 2.88058 13.5992C2.244 13.9934 1.73083 14.5583 1.39945 15.2297C1.06806 15.9011 0.931771 16.652 1.00608 17.3971C1.08039 18.1421 1.36231 18.8513 1.81977 19.444C2.27723 20.0368 2.89187 20.4892 3.59376 20.7499C4.29565 21.0105 5.05661 21.069 5.79006 20.9185C6.52352 20.7681 7.20003 20.4148 7.74263 19.8989C8.28522 19.3829 8.67212 18.7251 8.85931 18.0001H13.1413C13.3294 18.723 13.7165 19.3786 14.2586 19.8925C14.8006 20.4064 15.4759 20.758 16.2078 20.9074C16.9397 21.0568 17.6987 20.998 18.3988 20.7376C19.0989 20.4772 19.712 20.0257 20.1683 19.4344C20.6247 18.8431 20.9061 18.1356 20.9806 17.3924C21.0551 16.6492 20.9197 15.9 20.5897 15.2298C20.2598 14.5597 19.7485 13.9956 19.1141 13.6014C18.4796 13.2073 17.7473 12.9989 17.0003 13.0001V13.0001ZM13.1413 16.0001H8.85931C8.60536 15.0169 7.98639 14.1672 7.12831 13.6241L9.92131 8.83411C10.6245 9.05613 11.3791 9.05613 12.0823 8.83411L14.8823 13.6201C14.0193 14.162 13.3963 15.0135 13.1413 16.0001V16.0001Z" fill="white" />
                                </svg>
                                <p className="text-primary text-[20px] font-bakbak  font-normal" type="">99</p>

                            </div>
                        </div>
                        <div className="max-w-[31rem] bg-third p-[2rem] rounded-[1rem]">
                            <p className="text-white text-[20px] font-bakbak mb-[1.2rem] font-normal ">Total Earn</p>
                            <div className="w-auto flex justify-between ">
                                <div className="flex justify-start items-center gap-[0.6rem]">
                                    <div className="w-[2.4rem] h-[2.4rem]">
                                        <img src={Token} alt="token" />
                                    </div>
                                    <p className="text-primary text-[20px] font-bakbak  font-normal" type="">$1,999.00</p>
                                </div>
                                <button type="button" className="ml-[1.3rem] bg-primary rounded-full px-[2.2rem] text-[1.2rem] leading-[2.4rem] font-bakbak text-black font-normal">Withdraw</button>
                            </div>
                        </div>
                    </div>
                    <div className="bg-third p-[2rem] rounded-[1rem] mt-[2rem]">
                        <p className="text-white text-[20px] font-bakbak mb-[2rem] font-normal">Multi-Level Commision</p>
                        <table className="w-full">
                            <thead>
                                <tr>
                                    <td className=' py-[1.2rem] text-white text-[20px] font-bakbak font-normal'>Level</td>
                                    <td className=' py-[1.2rem] text-white text-[20px] font-bakbak font-normal  text-end'>Commission</td>
                                </tr>
                            </thead>
                            <tbody >
                                {listLevelCommission.map((item, index) => (
                                    <tr key={index}>
                                        <td className="py-[1.2rem] text-[#C2C3C5] text-start text-[16px] font-bakbak font-normal">{item.level}</td>
                                        <td className="py-[1.2rem] text-[#C2C3C5] text-[16px] text-end font-bakbak ">{item.commision}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
               </div>
        </>
    )
}

export default RefferalProgramPage;